<script setup lang="ts">
interface Tab { key: string; label: string }
defineProps<{ tabs: readonly Tab[]; modelValue: string }>()
defineEmits<{ 'update:modelValue': [key: string] }>()
</script>

<template>
  <div class="ck-tabs" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      role="tab"
      class="ck-tabs-btn"
      :class="{ active: modelValue === tab.key }"
      :aria-selected="modelValue === tab.key"
      @click="$emit('update:modelValue', tab.key)"
    >{{ tab.label }}</button>
  </div>
</template>

<style scoped>
.ck-tabs { display: flex; gap: 4px; padding: 4px; border-radius: var(--radius-md); background: var(--ck-cream-200); }
.ck-tabs-btn { flex: 1; min-height: 38px; padding: 8px 12px; border: 0; border-radius: 9px; background: transparent; color: var(--ck-text-muted); font: inherit; font-weight: var(--fw-bold); font-size: var(--fs-sm); cursor: pointer; transition: background 160ms ease-out, color 160ms ease-out, box-shadow 160ms ease-out; }
.ck-tabs-btn.active { background: var(--ck-cream-50); color: var(--ck-maroon-700); box-shadow: var(--shadow-sm); }
@media (prefers-reduced-motion: reduce) { .ck-tabs-btn { transition: none; } }
</style>
